import { gql } from "@/services/httpAdapter";

const GpsLotFragment = gql`
	fragment Lot on GpsLot {
		_id
		name
		address
		updatedAt
		points {
			lat
			lng
		}
	}
`;

const GlobalPositioningServiceFragment = gql`
	fragment GlobalPositioningService on GlobalPositioningService {
		lojack {
			provider
			providerName
			gpsStoreId
			gpsStoreName
			authRoleStatuses {
				role
				username
				isLoggedIn
			}
			allowableDistance {
				distance
				unit
			}
		}
		lots {
			...Lot
		}
	}

	${GpsLotFragment}
`;

const KeyManagementSystemFragment = gql`
	fragment KeyManagementSystem on KeyManagementSystem {
		oneMicro {
			provider
			providerName
			authRoleStatuses {
				role
				username
				isLoggedIn
			}
			allowableTimeAway {
				timeAway
				unit
			}
			chargebackAmount
			kmsStores {
				id
				name
				saleKiosks {
					id
					name
					selected
				}
				serviceKiosks {
					id
					name
				}
			}
		}
		keyTrack {
			provider
			providerName
			authRoleStatuses {
				role
				username
				isLoggedIn
			}
			allowableTimeAway {
				timeAway
				unit
			}
			chargebackAmount
		}
	}
`;

const AdministrationToolsIntegrationsFragment = gql`
	fragment Integrations on Integrations {
		dmsProvider {
			providerName
			provider
			systemTenantId
			dataSource
			userID
			hasDealerNumber
			storeNumber
			areaNumber
		}
		dmsSources {
			_id
			label
			value
		}
		dmsControlTypes {
			identifier
			label
			value
		}
		generalLedgerPrefix {
			_id
			oemName
			oemReference
			prefixes
		}
		reputationManagement {
			provider
			commissionCycleLastUpdate {
				intendedCycle
				dayOfTheMonth
			}
		}
		opportunityMining {
			_id
			provider {
				_id
				providerName
				configuration {
					associationWindow
				}
			}
		}
		reynoldsInventoryMapping {
			new {
				name
				mappedName
				isEditable
				isActive
				isCustom
			}
			preOwned {
				name
				mappedName
				isEditable
				isActive
				isCustom
			}
		}
		globalPositioningService {
			...GlobalPositioningService
		}
		keyManagementSystem {
			...KeyManagementSystem
		}
		customerRelationshipManagement {
			providerName
			provider
			systemTenantId
			dataSource
			hasDealerNumber
			storeNumber
			areaNumber
		}
		phoneServiceProvider {
			providerName
		}
		defaultTradeAmount {
			newVehicle {
				reference
				modifier {
					value
					type
				}
			}
			preOwnedVehicle {
				reference
				modifier {
					value
					type
				}
			}
		}
		payrollProviders {
			providerName
			configuredAccounts {
				companyId
				displayId
				status
				statusDate
			}
		}
	}
	${GlobalPositioningServiceFragment}
	${KeyManagementSystemFragment}
`;

export { AdministrationToolsIntegrationsFragment, GlobalPositioningServiceFragment, KeyManagementSystemFragment, GpsLotFragment };
